import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list'; 
import { MatTabsModule } from '@angular/material/tabs';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { FormsModule } from '@angular/forms';

import { TopSecondaryNavComponent } from './top-secondary-nav/top-secondary-nav.component';
import { MatSideNavComponent } from './mat-side-nav/mat-side-nav.component';

@NgModule({
	declarations: [
		TopSecondaryNavComponent
		, MatSideNavComponent
	]
    , imports: [
		RouterModule
		, CommonModule
		, FormsModule
		, MatTabsModule
		, MatListModule
        , MatSidenavModule
		, FontAwesomeModule
	]
    , exports: [ 
		TopSecondaryNavComponent
		, MatTabsModule 
		, MatListModule
        , MatSidenavModule
		, FontAwesomeModule
		, MatSideNavComponent
	]
})
export class NavigationModule { }
